import { useEffect } from "react";

function Forms() {
  useEffect(() => {
    document.title = "Forms";
  }, []);

  return (
    <div className="content">
      <div className="w-container">
        <div className="page-head">
          <div className="page-title">
            <h1 className="h1">All Forms</h1>
          </div>
          <div class="sub-hrule"></div>
          <p className="paragraph-center sub">
            Collection of all forms used throughout the college. <br />
            (Hint: ctrl-F to quickly find the form you&#x27;re looking for)
          </p>
        </div>
        <div className="forms-grid">
          <a
            id="form"
            href="https://docs.google.com/forms/d/e/1FAIpQLSdA-cPoab2-_cpES7NmltroDcQkY-fBpPoTH1exmP-LCf9YOg/viewform?c=0&amp;w=1"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Room Reservation</h3>
          </a>
          <a
            id="form"
            href="https://docs.google.com/forms/d/e/1FAIpQLScmNEuSV90J8C28-CjW7pQb9geDbbC86wmgG-8v_Sbr4jleuw/viewform?usp=header"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Cabinet Agenda Item</h3>
          </a>
          <a
            id="form"
            href="https://docs.google.com/forms/d/e/1FAIpQLSeM0TXR4lgaVbQLMMgYctN6Bat7wOxtpUt0sdH0kgZu3L5I7Q/viewform?usp=sharing&ouid=103710458526261299487"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Submit Snaps</h3>
          </a>
          <a
            id="form"
            href="https://docs.google.com/forms/d/e/1FAIpQLSehOsZVYlFoLNFQQNzBeVvHGKvEUPleSjVOiESzAT_Fbfag5A/viewform"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Budget Request</h3>
          </a>
          <a
            id="form"
            href="https://docs.google.com/forms/d/e/1FAIpQLSeXsr5CQ7kXs6A2j_Ahj_fGwB3h5y9q9WmFj0lhBvD9Mkm8aw/viewform"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Turn in Receipts</h3>
          </a>
          {/* <a
            id="form"
            href="https://forms.gle/28NxYdpZBEkowoBW7"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Court Infractions Form</h3>
          </a> */}
          <a
            id="form"
            href="https://docs.google.com/forms/d/e/1FAIpQLSfCl-qLM0OpvyL0C0sQ-OZOR8v30Q9LZQlxciGvNiCAY7DwBA/viewform"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Income Accessibility</h3>
          </a>
          {/* <a
            id="form"
            href="https://forms.gle/CTXvDB7X2YoxGmyd7"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Freshman Hours</h3>
          </a> */}
          {/* <a
            id="form"
            href="https://forms.gle/9Z3ok8o4rPa58dLu9"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Submit Announcement Links</h3>
          </a> */}
          <a
            id="form"
            href="https://docs.google.com/forms/d/e/1FAIpQLSfhtwd5k_2bUncBoGW4jYOeU-jZYn9MvDtzQwjHpd1skvDp0A/viewform?usp=sharing&ouid=103710458526261299487"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Wiess Feedback Form</h3>
          </a>
          <a
            id="form"
            href="https://docs.google.com/forms/d/e/1FAIpQLScGTfDlimg_zXhCTqWfqi74Lu3wi-1f2IRtihRnbfgENFegpg/viewform?gxids=7757"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Academic Assistance</h3>
          </a>
          {/* <a
            id="form"
            href="https://forms.gle/wu9TzR1NiY3UJynN8"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Capital Improvements</h3>
          </a> */}
          {/* <a
            id="form"
            href="https://docs.google.com/forms/d/e/1FAIpQLScUACDyYKKOqgfQp2e9ayT0mNMHAL2qU6QULjaPeG01s_m-VQ/viewform?c=0&amp;w=1"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Board Game Checkout</h3>
          </a> */}
          {/* <a
            id="form"
            href="https://docs.google.com/forms/d/e/1FAIpQLSc96__LXV2BuEOppiKtXDUbd7res450J6Yu-epHhSQJZpbAgg/viewform"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Greenware Checkout</h3>
          </a> */}
          {/* <a
            id="form"
            href="https://docs.google.com/forms/d/e/1FAIpQLSf8Z_Jk59RJGOhBtAOfQPJafI9RgRhVoINdsYiOTSXupuU5LQ/viewform"
            className="form-link w-inline-block"
          >
            <h3 className="h3">T-Shirt Screen</h3>
          </a> */}
          {/* <a
            id="form"
            href="https://docs.google.com/forms/d/e/1FAIpQLSe33X9glnLufFp_IxinrTUNqatKe4nzA-ohCetePkxRqI8Otg/viewform"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Pig Proclaimer</h3>
          </a> */}
          {/* <a
            id="form"
            href="https://forms.gle/76qrwD5e9qmANWDD8"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Weekly Announcement</h3>
          </a> */}
          <a
            id="form"
            href="https://docs.google.com/forms/d/e/1FAIpQLScfX46DnQB73T5BXof9Ia8XyvUJxEbnhNChtR3UOjZNylSMaA/viewform"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Check Out A Book</h3>
          </a>
          <a
            id="form"
            href="https://rice.tririga.com"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Work Order Form</h3>
          </a>
          <a
            id="form"
            href="https://forms.gle/qStBGKj4G35sZKwx7"
            className="form-link w-inline-block"
          >
            <h3 className="h3">South Servery Feedback Form</h3>
          </a>
          <a
            id="form"
            href="https://docs.google.com/forms/u/0/d/1TPfFU_k61cTw1SLBz2sG2TrHWTPtSU3gL90KVMg-hQQ/viewform?usp=drivesdk&edit_requested=true"
            className="form-link w-inline-block"
          >
            <h3 className="h3">P-Card Reporting</h3>
          </a>
          {/* <a
            id="form"
            href="https://docs.google.com/forms/d/e/1FAIpQLSdrv7Nk26Z1lL3HYbYwKD0_4EdPj2OpL8Hc2C1yFxSPOb_6nQ/viewform"
            className="form-link w-inline-block"
          >
            <h3 className="h3">Recommend A Book </h3>
          </a> */}
        </div>
      </div>
    </div>
  );
}

export default Forms;
